import * as colors from 'HubStyleTokens/colors';
import I18n from 'I18n';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { usageTracker } from '../../usage-tracker/usageTracker';
import { getUsageTrackingChannel } from '../../usage-tracker/trackerChannelIdMapping';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledUIButton = styled(UIButton).withConfig({
  displayName: "ContactPromotionButton__StyledUIButton",
  componentId: "sc-1pabqfr-0"
})(["border-radius:4px;width:28px;height:28px;padding:0px !important;margin-left:5px;vertical-align:inherit !important;&:hover{background:", " !important;}&:active{background:", " !important;}"], colors.GYPSUM, colors.BATTLESHIP);
const StyledUIIcon = styled(UIIcon).withConfig({
  displayName: "ContactPromotionButton__StyledUIIcon",
  componentId: "sc-1pabqfr-1"
})(["color:", ";"], props => props.$disabled ? colors.BUTTON_DISABLED_TEXT : `${colors.SLINKY} !important`);
const ContactPromotionButton = ({
  setShowContactPromotionModal,
  isDeletedContact = false,
  genericChannelId
}) => {
  const handleOnClick = () => {
    setShowContactPromotionModal(true);
    usageTracker.track('contact-promotion', {
      action: 'contact promotion button clicked',
      channel: genericChannelId && getUsageTrackingChannel(genericChannelId)
    });
  };
  const unKnownVisitorTooltip = I18n.text('conversations-inbox-message-history.common-message.sender.unknownVisitorSearchIconTooltip');
  const deletedContactToolTip = I18n.text('conversations-inbox-message-history.common-message.sender.deletedContactSearchIconTooltip');
  return /*#__PURE__*/_jsx(UITooltip, {
    title: isDeletedContact ? deletedContactToolTip : unKnownVisitorTooltip,
    children: /*#__PURE__*/_jsx(StyledUIButton, {
      use: "transparent",
      disabled: isDeletedContact,
      onClick: handleOnClick,
      "data-test-id": "contact-promotion-btn",
      children: /*#__PURE__*/_jsx(StyledUIIcon, {
        name: 'search',
        size: 16,
        $disabled: isDeletedContact
      })
    })
  });
};
ContactPromotionButton.displayName = 'ContactPromotionButton';
export default ContactPromotionButton;